// extracted by mini-css-extract-plugin
export default {"container":"fH1mQVB4zj4ejbYMe75r"};